import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHospitalCredentials } from '../redux/actions/user/hospital/Account/login';

export const useInitializeCredentials = () => {
  const dispatch = useDispatch();
  const { credentials } = useSelector((state) => state.hospitalAuth);

  useEffect(() => {
    if (!credentials) {
      const stored = localStorage.getItem('hospitalCredentials');
      console.log('useInitializeCredentials stored: ', stored);
      if (stored) {
        dispatch(setHospitalCredentials(stored));
      }
    }
  }, [dispatch, credentials]);

  console.log('useInitializeCredentials credentials: ', credentials);
};
